import { render } from "./CrossStep2.vue?vue&type=template&id=5a9c861c"
import script from "./CrossStep2.vue?vue&type=script&lang=js"
export * from "./CrossStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__